// src/polyfills-node.js
/* global globalThis */

import { Buffer } from 'buffer';
import processPolyfill from 'process';
// keep a single global copy, like Node does
if (!globalThis.Buffer) globalThis.Buffer = Buffer;
if (!globalThis.process) globalThis.process = processPolyfill;
